export default __webpack_public_path__ + "static/media/stream-icon-bottom-nav-mobile.ee07ac20.webp";